import * as en from './en/platypus.json';

/**
 * Platypus app translations
 */
export const translations = {
  en: { platypus: en },
};
